import React, { useEffect, useState, useRef } from "react";
import { useGlobal } from "../global/user";
import { Modal, Table, Form, Input, Select, Button, TimePicker, Tabs, Space, Checkbox, message } from "antd";
import { User, Field, Report, Line } from "../api";
import LineModal from "./modal/LineModal";
import moment from "moment";
import axios from "axios";
const { Option } = Select;
const server = process.env.REACT_APP_FASTAPI;
const DEFAULT_TIME_RANGE = [moment("07:00", "HH:mm"), moment("19:00", "HH:mm")];

export default function MessageTable() {
  const [textTokens, setTextTokens] = useState([]);
  const [textTokenData, setTextTokenData] = useState([]);
  const [addTokenModal, setAddTokenModal] = useState(false);
  const [editTokenModalVisible, setEditTokenModalVisible] = useState(false);
  const [editToken, setEditToken] = useState(null);
  const [groups, setGroups] = useState([]);
  const [tokenForm] = Form.useForm();
  const [timeForm] = Form.useForm();
  const [imageTimeForm] = Form.useForm();
  const { fields, user } = useGlobal();
  const [onDeleteField, setOnDeleteField] = useState(false);
  const [onDeleteLineToken, setOnDeleteLineToken] = useState(false);
  const [onDeleteImageLineToken, setOnDeleteImageLineToken] = useState(false);
  const [target] = useState();
  const [onEdit, setOnEdit] = useState(false);
  const [onLine, setOnLine] = useState(false);
  const [onTime, setOnTime] = useState(false);
  const [temp] = useState();

  const [textKeyword, setTextKeyWord] = useState("");
  const columns = [
    {
      title: "場域名稱",
      dataIndex: "field_name",
      filterSearch: true,
      onFilter: (value, record) => new RegExp(value, "i").test(record.field_name),
      filters: [...new Set(fields.map((m) => m.field_name))].map((field_name) => ({
        text: field_name,
        value: field_name,
      })),
    },
    { title: "機具數目", dataIndex: "count", align: "center", width: 70 },
    { title: "日報群組", dataIndex: "ReportGroup", width: 200 },
    { title: "警報群組", dataIndex: "WarningGroup", width: 200 },
    { title: "伺服器群組", dataIndex: "ServerGroup", width: 120, align: "center" },
    { title: "創建時間", dataIndex: "create_time" },
    { title: "主管", dataIndex: "name" },
  ];
  const refreshGroups = () => {
    axios.get(server + "token/get/text").then((res) => {
      const data = res.data.data;
      setTextTokens(
        data.map((record) => {
          return { ...record };
        })
      );
      setGroups(data.filter((e) => e.group_id !== "" && e.group_id !== null));
    });
  };

  useEffect(() => {
    refreshGroups();
  }, []);
  useEffect(() => {
    if (textKeyword.length === 0) {
      setTextTokenData(textTokens);
      return;
    }
    setTextTokenData(
      textTokens.filter((line) => {
        if ((line.name ?? "").search(new RegExp(textKeyword, "i")) !== -1) return true;
        if (((line.id?.toString() ?? "")).search(textKeyword) !== -1) return true;
        if ((line.token ?? "").search(textKeyword) !== -1) return true;
        return false;
      })
    );
  }, [textTokens]);
  useEffect(() => {
    if (editToken) {
      tokenForm.setFieldsValue({
        name: editToken.name,
        token: editToken.token,
        group_id: editToken.group_id,
      });
    }
  }, [editToken, tokenForm]);
  return (
    <React.Fragment>
      <div style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "8px"  }}>
        <Space style={{ display: "inline-flex" }}>
          <Button
            onClick={() => {
              setOnLine(true);
            }}
            hidden={user.class < process.env.REACT_APP_MANAGER_CALSS_LV}
          >
            管理通報群組
          </Button>
          <Button
            onClick={() => {
              setOnTime(true);
            }}
            hidden={user.class < process.env.REACT_APP_MANAGER_CALSS_LV}
          >
            管理通報時間
          </Button>
          <Button
            onClick={() => {
              setAddTokenModal(true);
            }}
            hidden={user.class < process.env.REACT_APP_MANAGER_CALSS_LV}
          >
            管理LINE token
          </Button>
        </Space>
      </div>
      <Table
        columns={columns}
        dataSource={fields}
        rowKey="field_id"
        pagination={{
          defaultPageSize: 10,
          showTotal: (total) => `共 ${total} 筆資料`,
        }}
        scroll={{ x: "max-content" }}
        bordered
      />
      <FieldEditModel visible={onEdit} setVisible={setOnEdit} field={target} />
      <LineModal visible={onLine} setVisible={setOnLine} tokens={textTokens} groups={groups} onRefreshGroups={refreshGroups} />
      <TimeModal visible={onTime} setVisible={setOnTime} timeForm={timeForm} imageTimeForm={imageTimeForm} />
      <Modal
        title="管理文字 LINE token"
        open={addTokenModal}
        onCancel={() => setAddTokenModal(false)}
        footer={[
          <Button key="back-button" onClick={() => setAddTokenModal(false)}>
            返回
          </Button>,
        ]}
        width={900}
      >
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }}
            onClick={() => {
              setEditToken(null);
              tokenForm.resetFields();
              setEditTokenModalVisible(true);
            }}
          >
            新增 Token
          </Button>
          
          <div style={{ display: "flex", gap: "8px" }}>
            <Input 
              placeholder="輸入關鍵字" 
              onChange={(e) => {
                const keyword = e.target.value;
                setTextKeyWord(keyword);
                if (keyword.length === 0) {
                  setTextTokenData(textTokens);
                  return;
                }
                setTextTokenData(
                  textTokens.filter((line) => {
                    if ((line.name ?? "").search(new RegExp(keyword, "i")) !== -1) return true;
                    if (((line.id?.toString() ?? "")).search(keyword) !== -1) return true;
                    if ((line.token ?? "").search(keyword) !== -1) return true;
                    return false;
                  })
                );
              }}
            />
          </div>
        </div>

        <Table
          columns={[
            { title: "序號", dataIndex: "id", key: "id", sorter: (a, b) => a.id - b.id, width: 80 },
            { title: "群組名稱", dataIndex: "name", key: "name" },
            { title: "Group ID", dataIndex: "group_id", key: "group_id", width: 290 },
            {
              title: "動作",
              width: 150,
              render: ({ id, name, token, group_id }) => (
                <Space>
                  <Button
                    onClick={() => {
                      setEditToken({ id, name, token, group_id });
                      setEditTokenModalVisible(true);
                    }}
                  >
                    編輯
                  </Button>
                  <Button
                    onClick={() => {
                      axios
                        .post(server + "token/delete/text", { token: id })
                        .then(() => {
                          setTextTokens(textTokens.filter((record) => record.id !== id));
                          alert("刪除成功");
                        })
                        .catch(() => alert("刪除失敗"));
                    }}
                  >
                    刪除
                  </Button>
                </Space>
              ),
            },
          ]}
          dataSource={textTokenData}
          rowKey="id"
          pagination={{
            defaultPageSize: 10,
            showTotal: (total) => `共 ${total} 筆資料`,
          }}
          scroll={{ x: "max-content", y: 330 }}
          bordered
        />
      </Modal>
      
      <Modal
        title={editToken ? "編輯 Token" : "新增 Token"}
        open={editTokenModalVisible}
        onCancel={() => {
          setEditTokenModalVisible(false);
          setEditToken(null);
          tokenForm.resetFields();
        }}
        footer={null}
        width={600}
      >
        <Form
          form={tokenForm}
          onFinish={({ name, group_id }) => {
            const data = { 
              id: editToken?.id ?? "", 
              name: name, 
              token: editToken?.token ?? "", 
              group_id: group_id 
            };
            axios
              .post(server + "token/post/text", data)
              .then((result) => {
                console.log(result);
                if (editToken) {
                  setTextTokens(textTokens.map((record) => (record.id === editToken.id ? { ...record, name, group_id } : record)));
                } else {
                  setTextTokens([...textTokens, { id: result.data.id, name: name, token: "", group_id: group_id }]);
                }
                refreshGroups();
                message.success("新增/更改token成功");
                setEditToken(null);
                tokenForm.resetFields();
                setEditTokenModalVisible(false);
              })
              .catch(() => message.error("新增/更改token失敗"));
          }}
          layout="vertical"
        >
          <Form.Item
            label="群組名稱"
            name="name"
            rules={[{ required: true, message: "不可為空" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Group ID"
            name="group_id"
          >
            <Input />
          </Form.Item>
          <Space>
            <Button type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }} htmlType="submit">
              {editToken ? "更新" : "新增"}
            </Button>
            <Button
              onClick={() => {
                setEditTokenModalVisible(false);
                tokenForm.resetFields();
                setEditToken(null);
              }}
            >
              取消
            </Button>
          </Space>
        </Form>
      </Modal>
      
      <Modal
        title="確認刪除"
        open={onDeleteField}
        onCancel={() => {
          setOnDeleteField(false);
        }}
        onOk={() => {
          const { field_id } = target;
          Field.deleteField(field_id);
          setOnDeleteField(false);
        }}
      >
        <p>確認是否刪除這個場域?</p>
      </Modal>
      <Modal
        title="確認刪除"
        open={onDeleteLineToken}
        onCancel={() => setOnDeleteLineToken(false)}
        footer={[
          <Button
            key="finish-edit"
            variant="filled"
            color="red"
            onClick={() => {
              setOnDeleteLineToken(false);
            }}
          >
            刪除
          </Button>,
          <Button key="back-button" onClick={() => setOnDeleteLineToken(false)}>
            返回
          </Button>,
        ]}
        width={500}
      >
        <p>
          確認是否刪除
          <br />
          {temp}?
        </p>
      </Modal>
      <Modal
        title="確認刪除"
        open={onDeleteImageLineToken}
        onCancel={() => setOnDeleteImageLineToken(false)}
        footer={[
          <Button
            key="finish-edit"
            variant="filled"
            color="red"
            onClick={() => {
              axios
                .delete(`${server}api/v1/image/delete?token=${temp}`)
                .then(() => alert("刪除成功"))
                .catch(() => alert("刪除失敗"));
              setOnDeleteImageLineToken(false);
            }}
          >
            刪除
          </Button>,
          <Button key="back-button" onClick={() => setOnDeleteImageLineToken(false)}>
            返回
          </Button>,
        ]}
        width={500}
      >
        <p>
          確認是否刪除
          <br />
          {temp}?
        </p>
      </Modal>
    </React.Fragment>
  );
}

function FieldEditModel({ field, visible, setVisible }) {
  const formItemLayout = {
    labelCol: {
      sm: {
        span: 5,
      },
    },
    wrapperCol: {
      sm: {
        span: 15,
      },
    },
  };
  const [form] = Form.useForm();
  const [managers, setManagers] = useState([]);
  const [LineGroups, setLineGroups] = useState([]);
  const { setFields } = useGlobal();

  useEffect(() => {
    const fetchData = async () => {
      if (!visible) return;
      let response = await User.GetManagers();
      if (response.code === 200) setManagers(response.data);
      response = await Line.GetLineData();
      if (response.code === 200) setLineGroups(response.data);
      if (field) form.setFieldsValue(field);
      else form.resetFields();
    };

    fetchData();
  }, [visible, field, form]);

  const onSubmit = async () => {
    const { field_name, manager_id, report_line_id, warning_line_id, server_line_id } = form.getFieldsValue();
    if (field) {
      const response = await Field.UpdateField(field.field_id, field_name, manager_id, report_line_id, warning_line_id, server_line_id);
      if (response.code === 200)
        setFields((data) =>
          [...data].map((field) => {
            if (field.field_id === response.data.field_id) return response.data;
            return field;
          })
        );
    } else {
      const response = await Field.CreateField(field_name, manager_id, report_line_id, warning_line_id, server_line_id);
      if (response.code === 200) setFields((data) => [...data, response.data]);
    }
    setVisible(false);
  };
  return (
    <Modal
      open={visible}
      title={field ? "編輯場域" : "新增場域"}
      onCancel={() => setVisible(false)}
      onOk={() => form.submit()}
      okText="完成編輯"
      cancelText="返回"
    >
      <Form form={form} onFinish={onSubmit} {...formItemLayout}>
        <Form.Item label="場域名稱" name="field_name" rules={[{ required: true, message: "請輸入場域名稱" }]}>
          <Input />
        </Form.Item>
        <Form.Item label="主管" name="manager_id" rules={[{ required: true, message: "請選擇單位主管" }]}>
          <Select>
            {managers.map(({ value, text }) => (
              <Option value={value} key={value}>
                {text}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="日報群組" name="report_line_id" rules={[{ required: true, message: "請選擇通報群組" }]}>
          <Select>
            {LineGroups.map(({ id, name }) => (
              <Option value={id} key={id}>
                {name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="警報群組" name="warning_line_id" rules={[{ required: true, message: "請選擇通報群組" }]}>
          <Select>
            {LineGroups.map(({ id, name }) => (
              <Option value={id} key={id}>
                {name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="伺服器群組" name="server_line_id" rules={[{ required: true, message: "請選擇通報群組" }]}>
          <Select>
            {LineGroups.map(({ id, name }) => (
              <Option value={id} key={id}>
                {name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}

function TimeModal({ visible, setVisible, timeForm, imageTimeForm }) {
  const [onEdit, setOnEdit] = useState(false);
  const [onImageEdit, setOnImageEdit] = useState(false);
  const [data, setData] = useState([]);
  const [reportOptions, setReportOptions] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [imageOptions, setImageOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [reportSearchKeyword, setReportSearchKeyword] = useState("");
  const [imageSearchKeyword, setImageSearchKeyword] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (visible !== true) return;
      if (activeTab === "1") {
        setLoading(true);
        const response = await Report.GetReportData();
        if (response.code === 200) {
          setData(response.data);
        }
        const optionResponse = await Report.GetReportOption();
        if (optionResponse.code === 200) {
          setReportOptions(optionResponse.data);
        }
        setLoading(false);
      } else if (activeTab === "2") {
        setImageLoading(true);
        const response = await Report.GetImageReportData();
        console.log(response.data);
        if (response.code === 200) {
          setImageData(response.data);
        }
        const optionResponse = await Report.GetImageReportOption();
        if (optionResponse.code === 200) {
          setImageOptions(optionResponse.data);
        }
        setImageLoading(false);
      }
    };

    fetchData();
  }, [visible, activeTab]);

  const onDelete = async (id) => {
    const response = await Report.DeleteReport(id);
    if (response.code === 200) {
      setData((data) => [...data].filter((report) => report.id !== id));
      if (onEdit && timeForm.getFieldValue("id") === id) {
        setOnEdit(false);
        timeForm.resetFields();
      }
    }
  };

  const onImageDelete = async (id) => {
    const response = await Report.DeleteImageReport(id);
    if (response.code === 200) {
      setImageData((data) => [...data].filter((report) => report.id !== id));
      if (onImageEdit && imageTimeForm.getFieldValue("id") === id) {
        setOnImageEdit(false);
        imageTimeForm.resetFields();
      }
    }
  };

  const confirmDelete = (id, name, type) => {
    Modal.confirm({
      title: "確認刪除",
      content: `確定要刪除「${name}」的通報時間嗎？`,
      okText: "確認",
      cancelText: "取消",
      onOk: () => {
        if (type === "report") {
          onDelete(id);
        } else if (type === "image") {
          onImageDelete(id);
        }
      },
    });
  };

  const handleRestartReportService = async () => {
    try {
      const response = await Report.RestartReportService();
      if (response.code === 200) {
        message.success("報告服務已成功重啟");
      } else {
        message.error(`重啟報告服務失敗: ${response.message}`);
      }
    } catch (error) {
      console.error("重啟服務時發生錯誤:", error);
      message.error("重啟報告服務失敗");
    }
    setVisible(false);
  };

  const filteredReportData = data.filter((item) => {
    if (!reportSearchKeyword) return true;
    const keyword = reportSearchKeyword.toLowerCase();
    return (item.name ?? "").toLowerCase().includes(keyword);
  });

  const filteredImageData = imageData.filter((item) => {
    if (!imageSearchKeyword) return true;
    const keyword = imageSearchKeyword.toLowerCase();
    const matchName = (item.name ?? "").toLowerCase().includes(keyword);
    const matchSerial = (item.serial_number ?? "").toLowerCase().includes(keyword);
    return matchName || matchSerial;
  });

  const columns = [
    { title: "場域名稱", dataIndex: "name" },
    { title: "通報時間", dataIndex: "time", align: "center" },
    { title: "規則", dataIndex: "day_filter", align: "center", render: (val) => {
          switch(val){
            case 1: return '六日不發';
            case 2: return '日不發';
            case 3: return '見紅不發';
            default: return '平假日都發';
          }
        } },
    {
      title: "設定",
      align: "center",
      render: ({ id, name, time, field_id, serial_number, day_filter }) => (
        <Space>
          <Button
            type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }}
            size="small"
            onClick={() => {
              setOnEdit(true);
              timeForm.setFieldsValue({
                id,
                time: moment(time, "HH:mm:ss"),
                field_id,
                serial_number,
                day_filter: day_filter || 0,
              });
            }}
          >
            編輯
          </Button>
          <Button danger size="small" onClick={() => confirmDelete(id, name, "report")}>
            刪除
          </Button>
        </Space>
      ),
    },
  ];

  const imageColumns = [
    { title: "場域名稱", dataIndex: "name" },
    { title: "機具序號", align: "center", dataIndex: "serial_number" },
    { title: "通報時間", align: "center", width: 100, dataIndex: "time" },
    { title: "規則", dataIndex: "day_filter", align: "center", render: (val) => {
          switch(val){
            case 1: return '六日不發';
            case 2: return '日不發';
            case 3: return '見紅不發';
            default: return '平假日都發';
          }
        } },
    {
      title: "存beta",
      dataIndex: "is_sftp_download",
      width: 100,
      align: "center",
      render: (value) => <div style={{ display: "flex", justifyContent: "center" }}>{value ? "是" : "否"}</div>,
    },
    {
      title: "設定",
      align: "center",
      render: ({ id, name, time, field_mobile_id, serial_number, is_sftp_download, day_filter, is_ftp_scan, ftp_scan_time, scan_time_gap, scan_cd }) => (
        <Space>
          <Button
            type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }}
            size="small"
            onClick={() => {
              setOnImageEdit(true);
              imageTimeForm.setFieldsValue({
                id,
                time: moment(time, "HH:mm:ss"),
                field_mobile_id,
                serial_number,
                is_sftp_download: is_sftp_download || false,
                is_ftp_scan: is_ftp_scan || false,
                ftp_scan_time: ftp_scan_time || {"start_time": "07:00", "end_time": "19:00"},
                scan_time_range: ftp_scan_time
                  ? [moment(ftp_scan_time.start_time, "HH:mm"), moment(ftp_scan_time.end_time, "HH:mm")]
                  : [moment("07:00", "HH:mm"), moment("19:00", "HH:mm")],
                scan_time_gap: scan_time_gap ?? "",
                scan_cd: scan_cd ?? "",
                day_filter: day_filter || 0,
              });
            }}
          >
            編輯
          </Button>
          <Button danger size="small" onClick={() => confirmDelete(id, name, "image")}>
            刪除
          </Button>
        </Space>
      ),
    },
  ];

  const onSubmitReport = async () => {
    const { id, field_id, time, serial_number, day_filter } = timeForm.getFieldsValue();
    let response;

    if (!onEdit) {
      response = await Report.CreateReport({
        field_id,
        time: time.format("HH:mm:ss"),
        serial_number: serial_number || null,
        day_filter: day_filter || 0,
      });
      if (response.code === 200) {
        setData((data) => [...data, response.data]);
      }
    } else {
      response = await Report.UpdateReport({
        id,
        field_id,
        time: time.format("HH:mm:ss"),
        serial_number: serial_number || null,
        day_filter: day_filter || 0,
      });
      if (response.code === 200) {
        setData((data) => [...data].map((report) => (report.id === response.data.id ? response.data : report)));
      }
      setOnEdit(false);
    }

    if (response && response.code === 200) {
      const reload = await Report.GetReportData();
      if (reload.code === 200) setData(reload.data);
    }

    timeForm.resetFields();
  };

  const onSubmitImageReport = async () => {
    const { id, field_mobile_id, time, serial_number, is_sftp_download, is_ftp_scan, scan_time_range, scan_time_gap, scan_cd, day_filter } = imageTimeForm.getFieldsValue();
    let response;

    const ftp_scan_time = scan_time_range
      ? { start_time: scan_time_range[0].format("HH:mm"), end_time: scan_time_range[1].format("HH:mm") }
      : { start_time: "07:00", end_time: "19:00" };

    const payload = {
      field_mobile_id,
      time: time.format("HH:mm:ss"),
      serial_number,
      is_sftp_download: is_sftp_download || false,
      is_ftp_scan: is_ftp_scan || false,
      ftp_scan_time: ftp_scan_time || {"start_time": "07:00", "end_time": "19:00"},
      scan_time_gap: scan_time_gap ?? null,
      scan_cd: scan_cd ?? null,
      day_filter: day_filter || 0,
    };

    if (!onImageEdit) {
      response = await Report.CreateImageReport(payload);
      if (response.code === 200) {
        setImageData((data) => [...data, response.data]);
      }
    } else {
      response = await Report.UpdateImageReport({
        id,
        ...payload,
      });
      if (response.code === 200) {
        setImageData((data) => [...data].map((report) => (report.id === response.data.id ? response.data : report)));
      }
      setOnImageEdit(false);
    }

    if (response && response.code === 200) {
      const reload = await Report.GetImageReportData();
      if (reload.code === 200) setImageData(reload.data);
    }

    imageTimeForm.resetFields();
  };

  const tabItems = [
    {
      key: "1",
      label: "場域日報",
      children: (
        <div style={{ display: "flex", gap: "16px" }}>
          {/* 左側表格區域 */}
          <div style={{ flex: "1", minWidth: "0" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <Input
                placeholder="搜尋場域名稱"
                value={reportSearchKeyword}
                onChange={(e) => setReportSearchKeyword(e.target.value)}
                style={{ width: 250 }}
                allowClear
              />
              <Button
                type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }}
                onClick={() => {
                  setOnEdit(false);
                  timeForm.resetFields();
                }}
              >
                新增場域日報
              </Button>
            </div>

            <Table
              columns={columns}
              dataSource={filteredReportData}
              loading={loading}
              rowKey="id"
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20"],
                showTotal: (total) => `共 ${total} 筆資料`,
                size: "default",
              }}
              bordered
              size="middle"
              scroll={{ y: 350 }}
            />
          </div>

          {/* 右側編輯區域 */}
          <div
            style={{
              width: "350px",
              padding: "16px",
              backgroundColor: "var(--modal-background)",
              borderRadius: "8px",
              border: "1px solid var(--border-color)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            }}
          >
            <h3 style={{ marginBottom: "16px", borderBottom: "1px solid var(--border-color)", paddingBottom: "8px", color: "var(--primary-text)" }}>{onEdit ? "編輯場域日報" : "新增場域日報"}</h3>

            <Form form={timeForm} onFinish={onSubmitReport} layout="vertical">
              <Form.Item name="id" className="d-none">
                <Input type="hidden" />
              </Form.Item>

              <Form.Item name="field_id" label="場域" rules={[{ required: true, message: "請選擇通報場域" }]} className="mb-2">
                <Select placeholder="請選擇通報場域">
                  {reportOptions.map((option) => (
                    <Option value={option.id} key={option.id}>
                      {option.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name="time" label="通報時間" rules={[{ required: true, message: "請選擇通報時間" }]} className="mb-2">
                <TimePicker style={{ width: "100%" }} format="HH:mm:ss" />
              </Form.Item>

              <Form.Item name="day_filter" label="排程規則" className="mb-2" initialValue={0}>
                <Select>
                  <Option value={0}>平假日都發</Option>
                  <Option value={1}>六日不發</Option>
                  <Option value={2}>日不發</Option>
                  <Option value={3}>見紅不發(含六日)</Option>
                </Select>
              </Form.Item>

              <div style={{ display: "flex", gap: "8px" }}>
                <Button type="default" htmlType="submit" style={{ flex: 1, background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }}>
                  {onEdit ? "完成編輯" : "新增"}
                </Button>

                <Button
                  onClick={() => {
                    setOnEdit(false);
                    timeForm.resetFields();
                  }}
                  style={{ flex: 1 }}
                >
                  {onEdit ? "取消編輯" : "清空"}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "影像機具日報",
      children: (
        <div style={{ display: "flex", gap: "16px" }}>
          {/* 左側表格區域 */}
          <div style={{ flex: "1", minWidth: "0" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <Input
                placeholder="搜尋場域名稱或機具序號"
                value={imageSearchKeyword}
                onChange={(e) => setImageSearchKeyword(e.target.value)}
                style={{ width: 250 }}
                allowClear
              />
              <Button
                type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }}
                onClick={() => {
                  setOnImageEdit(false);
                  imageTimeForm.resetFields();
                }}
              >
                新增影像機具日報
              </Button>
            </div>

            <Table
              columns={imageColumns}
              dataSource={filteredImageData}
              loading={imageLoading}
              rowKey="id"
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20"],
                showTotal: (total) => `共 ${total} 筆資料`,
              }}
              bordered
              scroll={{ y: 360 }}
            />
          </div>

          {/* 右側編輯區域 */}
          <div
            style={{
              width: "350px",
              padding: "16px",
              backgroundColor: "var(--modal-background)",
              borderRadius: "8px",
              border: "1px solid var(--border-color)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            }}
          >
            <h3 style={{ marginBottom: "16px", borderBottom: "1px solid var(--border-color)", paddingBottom: "8px", color: "var(--primary-text)" }}>
              {onImageEdit ? "編輯影像機具日報" : "新增影像機具日報"}
            </h3>

            <Form form={imageTimeForm} onFinish={onSubmitImageReport} layout="vertical">
              <Form.Item name="id" className="d-none">
                <Input type="hidden" />
              </Form.Item>

              <Form.Item name="field_mobile_id" label="影像機具" rules={[{ required: true, message: "請選擇影像機具" }]} className="mb-2">
                <Select placeholder="請選擇影像機具">
                  {imageOptions.map((option) => (
                    <Option value={option.id} key={option.id}>
                      {option.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name="serial_number" label="機具序號" rules={[{ required: true, message: "請輸入機具序號" }]} className="mb-2">
                <Input placeholder="請輸入機具序號" />
              </Form.Item>

              <Form.Item name="time" label="通報時間" rules={[{ required: true, message: "請選擇通報時間" }]} className="mb-2">
                <TimePicker style={{ width: "100%" }} format="HH:mm:ss" />
              </Form.Item>

              <Form.Item name="day_filter" label="排程規則" className="mb-2" initialValue={0}>
                <Select>
                  <Option value={0}>平假日都發</Option>
                  <Option value={1}>六日不發</Option>
                  <Option value={2}>日不發</Option>
                  <Option value={3}>見紅不發(含六日)</Option>
                </Select>
              </Form.Item>

              <Space size={20}>
                <Form.Item name="is_sftp_download" valuePropName="checked" className="mb-2">
                  <Checkbox>存在beta</Checkbox>
                </Form.Item>
              </Space>

              <Space direction="vertical" size={2} style={{ width: '100%' }}>
                <Form.Item name="is_ftp_scan" valuePropName="checked" className="mb-2">
                  <Checkbox>FTP定時辨識</Checkbox>
                </Form.Item>

                <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.is_ftp_scan !== currentValues.is_ftp_scan}>
                  {({ getFieldValue }) => {
                    return getFieldValue('is_ftp_scan') ? (
                      <Form.Item 
                        name="scan_time_range" 
                        label="辨識時段" 
                        className="mb-2"
                      >
                        <TimePicker.RangePicker 
                          style={{ width: "100%" }} 
                          format="HH:mm" 
                          placeholder={['開始時間', '結束時間']}
                          getPopupContainer={trigger => trigger.parentElement}
                          placement="bottomLeft"
                        />
                      </Form.Item>
                    ) : null;
                  }}
                </Form.Item>
                <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.is_ftp_scan !== currentValues.is_ftp_scan}>
                  {({ getFieldValue }) => {
                    return getFieldValue('is_ftp_scan') ? (
                      <Form.Item 
                        name="scan_time_gap" 
                        label="辨識時間間隔" 
                        className="mb-2"
                      >
                        <Input
                          placeholder={'輸入時間(秒)'}
                          style={{ width: "100%" }} 
                        />
                      </Form.Item>
                    ) : null;
                  }}
                </Form.Item>
                <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.is_ftp_scan !== currentValues.is_ftp_scan}>
                  {({ getFieldValue }) => {
                    return getFieldValue('is_ftp_scan') ? (
                      <Form.Item 
                        name="scan_cd" 
                        label="CD時間 (發報後一段時間不再發報)" 
                        className="mb-2"
                      >
                        <Input
                          placeholder={'輸入時間(秒)'}
                          style={{ width: "100%" }} 
                        />
                      </Form.Item>
                    ):null;
                  }}
                </Form.Item>

              </Space>
              <div style={{ display: "flex", gap: "8px" }}>
                <Button type="default" htmlType="submit" style={{ flex: 1, background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }}>
                  {onEdit ? "完成編輯" : "新增"}
                </Button>

                <Button
                  onClick={() => {
                    setOnImageEdit(false);
                    imageTimeForm.resetFields();
                  }}
                  style={{ flex: 1 }}
                >
                  {onEdit ? "取消編輯" : "清空"}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      ),
    },
  ];

  return (
    <Modal
      title="通報時間管理"
      open={visible}
      onCancel={() => {
        timeForm.resetFields();
        imageTimeForm.resetFields();
        setOnEdit(false);
        setOnImageEdit(false);
        setReportSearchKeyword("");
        setImageSearchKeyword("");
        setVisible(false);
      }}
      footer={[
        <Button onClick={handleRestartReportService} variant="filled" color="blue" key="restart-button">
          重啟服務
        </Button>,
        <Button onClick={() => {
          timeForm.resetFields();
          imageTimeForm.resetFields();
          setOnEdit(false);
          setOnImageEdit(false);
          setReportSearchKeyword("");
          setImageSearchKeyword("");
          setVisible(false);
        }} key="back-button">
          返回
        </Button>,
      ]}
      width={1200}
    >
      <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
    </Modal>
  );
}